var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            inline: "",
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.superior"), prop: "upIdList" }
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      options: _vm.options,
                      props: _vm.propstree,
                      disabled: _vm.keyValue > 0
                    },
                    on: { change: _vm.getNode },
                    model: {
                      value: _vm.childData.upIdList,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "upIdList", $$v)
                      },
                      expression: "childData.upIdList"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.parkingType") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.childData.parkingType,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "parkingType", $$v)
                        },
                        expression: "childData.parkingType"
                      }
                    },
                    _vm._l(_vm.typeOption, function(item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.dicValue } },
                        [_vm._v(_vm._s(item.dicName))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.leaseControl") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.childData.isLease,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "isLease", $$v)
                        },
                        expression: "childData.isLease"
                      }
                    },
                    _vm._l(_vm.rentOption, function(item) {
                      return _c(
                        "el-radio",
                        { key: item.id, attrs: { label: item.dicValue } },
                        [_vm._v(_vm._s(item.dicName))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("table.parkingCode"),
                    prop: "parkingCode"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请填写车位号"
                    },
                    model: {
                      value: _vm.childData.parkingCode,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "parkingCode", $$v)
                      },
                      expression: "childData.parkingCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.parkingOwner") } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: {
                        filterable: "",
                        clearable: "",
                        disabled: _vm.isDisabled,
                        loading: _vm.loading,
                        placeholder: "请输入(业主姓名/电话号码)"
                      },
                      on: { focus: _vm.checkMenuId },
                      model: {
                        value: _vm.childData.customerId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "customerId", $$v)
                        },
                        expression: "childData.customerId"
                      }
                    },
                    _vm._l(_vm.customerList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: {
                          label: item.customerName,
                          value: item.customerId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.parkingArea") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { min: 0, max: 99999, clearable: "", type: "text" },
                    model: {
                      value: _vm.childData.parkingArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "parkingArea", $$v)
                      },
                      expression: "childData.parkingArea"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.saleDate") } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "date",
                      placeholder: "选择出售日期",
                      format: "yyyy 年 MM 月 dd 日",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.childData.saleDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "saleDate", $$v)
                      },
                      expression: "childData.saleDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.carNumberOne") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请填写车牌号1"
                    },
                    model: {
                      value: _vm.childData.carNumberOne,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "carNumberOne", $$v)
                      },
                      expression: "childData.carNumberOne"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.carNumberTwo") } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请填写车牌号2"
                    },
                    model: {
                      value: _vm.childData.carNumberTwo,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "carNumberTwo", $$v)
                      },
                      expression: "childData.carNumberTwo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }